<template>
  <div>
    <v-dialog v-model="dialog" width="350px">
      <v-card class="product-group-dialog">
        <v-card-title class="grey lighten-2">
          {{ $t("modal.chooseYourDishes") }}
        </v-card-title>
        <div class="modal-content">
          <v-card-text v-if="starters.length > 0">
            <h3>{{ $t("common.first") }}</h3>
            <v-row>
              <v-col cols="12">
                <div v-for="(item, index) in starters" :key="index">
                  <v-row v-show="item.item !== ''">
                    <v-col cols="12">
                      <v-checkbox
                        hide-details
                        class="mt-0"
                        :label="checkBoxLabel(item)"
                        :value="item"
                        v-model="selectedStarters"
                        @change="selectStarters(item, index)"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text v-if="maincourse.length > 0 && !menuGroup.isStarter">
            <h3>{{ $t("common.second") }}</h3>
            <v-row>
              <v-col cols="12">
                <div v-for="(item, index) in maincourse" :key="index">
                  <v-row v-show="item.item !== ''">
                    <v-col cols="12">
                      <v-checkbox
                        hide-details
                        class="mt-0"
                        :label="checkBoxLabel(item)"
                        :value="item"
                        v-model="selectedMaincourse"
                        @change="selectMaincourse(item, index)"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text v-if="menuGroup.isDessert && dessert.length > 0">
            <h3>{{ $t("common.dessert") }}</h3>
            <v-row>
              <v-col cols="12">
                <div v-for="(item, index) in dessert" :key="index">
                  <v-row v-show="item.item !== ''">
                    <v-col cols="12">
                      <v-checkbox
                        hide-details
                        class="mt-0"
                        :label="checkBoxLabel(item)"
                        :value="item"
                        v-model="selectedDessert"
                        @change="selectDessert(item, index)"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text v-if="menuGroup.isDrink && drinks.length > 0">
            <h3>{{ $t("common.drinks") }}</h3>
            <v-row>
              <v-col cols="12">
                <div v-for="(item, index) in drinks" :key="index">
                  <v-row v-show="item.item !== ''">
                    <v-col cols="12">
                      <v-checkbox
                        hide-details
                        class="mt-0"
                        :label="checkBoxLabel(item)"
                        :value="item"
                        v-model="selectedDrinks"
                        @change="selectDrinks(item, index)"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="d-flex justify-end pb-3">
            <v-btn text @click="dialog = false">{{ $t("common.close") }}</v-btn>
            <v-btn outlined @click="onDone" :disabled="!validateMenuGroupItem">
              {{ $t("common.done") }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <CookingPointsDialog
      @setMenuGroupItem="setMenuGroupItem($event)"
      ref="cookingPointsDialog"
    ></CookingPointsDialog>
    <IngredienteDialog
      @setMenuGroupItem="setMenuGroupItem($event)"
      ref="ingredienteDialog"
    ></IngredienteDialog>
    <email-modal ref="emailModalRef"></email-modal>
  </div>
</template>

<script>
import CookingPointsDialog from "@/components/public/products/SelectItems/CookingPointsDialog";
import IngredienteDialog from "@/components/public/products/SelectItems/IngredienteDialog";
import EmailModal from "@/components/public/modals/EmailModal.vue";

const NO_QR = "NO QR";

export default {
  name: "group-product-dialog",
  props: {
    menuGroup: Object,
    drinks: Array,
    dessert: Array,
    starters: Array,
    maincourse: Array,
    isAdmin: Boolean
  },
  components: {
    CookingPointsDialog,
    IngredienteDialog,
    EmailModal
  },
  data() {
    return {
      dialog: false,
      selectedStarters: [],
      selectedMaincourse: [],
      selectedDrinks: [],
      selectedDessert: [],
      size: "base",
      disabledStarters: false,
      groupItemToCart: [],
      checkQR: false,
      menuGroupCart: [],
      menuGroupItems: []
    };
  },
  computed: {
    tableQR() {
      return !this.isAdmin
        ? this.$store.state.tableQR
        : this.$store.state.adminTableQR;
    },
    validateMenuGroupItem() {
      let checked = false;
      let checkedMain = false;
      let checkedStarter = false;
      let checkedDessert = false;
      let checkedDrinks = false;

      if (this.selectedMaincourse.length > 0) {
        checkedMain = this.selectedMaincourse.some(item => {
          let found = this.menuGroup.maincourse_ids.some(
            main => main.id === item.id
          );
          if (found) {
            return item;
          }
        });
      }
      if (this.selectedStarters.length > 0) {
        checkedStarter = this.selectedStarters.some(item => {
          let found = this.menuGroup.starter_ids.some(
            starter => starter.id === item.id
          );
          if (found) {
            return item;
          }
        });
      }
      if (this.selectedDrinks.length > 0) {
        checkedDrinks = this.selectedDrinks.some(item => {
          let found = this.menuGroup.drink_ids.some(
            drink => drink.id === item.id
          );
          if (found) {
            return item;
          }
        });
      }
      if (this.selectedDessert.length > 0) {
        checkedDessert = this.selectedDessert.some(item => {
          let found = this.menuGroup.dessert_ids.some(
            dessert => dessert.id === item.id
          );
          if (found) {
            return item;
          }
        });
      }

      if (
        this.menuGroup.maincourse_ids.length > 0 &&
        !this.menuGroup.isStarter &&
        this.menuGroup.starter_ids.length > 0 &&
        this.menuGroup.drink_ids.length > 0 &&
        this.menuGroup.isDrink &&
        this.menuGroup.dessert_ids.length > 0 &&
        this.menuGroup.isDessert
      ) {
        checked =
          checkedMain && checkedStarter && checkedDrinks && checkedDessert;
      } else if (
        this.menuGroup.maincourse_ids.length > 0 &&
        !this.menuGroup.isStarter &&
        this.menuGroup.starter_ids.length > 0 &&
        this.menuGroup.drink_ids.length > 0 &&
        this.menuGroup.isDrink
      ) {
        checked = checkedMain && checkedStarter && checkedDrinks;
      } else if (
        this.menuGroup.maincourse_ids.length > 0 &&
        !this.menuGroup.isStarter &&
        this.menuGroup.starter_ids.length > 0 &&
        this.menuGroup.dessert_ids.length > 0 &&
        this.menuGroup.isDessert
      ) {
        checked = checkedMain && checkedStarter && checkedDessert;
      } else if (
        this.menuGroup.maincourse_ids.length > 0 &&
        !this.menuGroup.isStarter &&
        this.menuGroup.drink_ids.length > 0 &&
        this.menuGroup.isDrink &&
        this.menuGroup.dessert_ids.length > 0 &&
        this.menuGroup.isDessert
      ) {
        checked = checkedMain && checkedDrinks && checkedDessert;
      } else if (
        this.menuGroup.starter_ids.length > 0 &&
        this.menuGroup.drink_ids.length > 0 &&
        this.menuGroup.isDrink &&
        this.menuGroup.dessert_ids.length > 0 &&
        this.menuGroup.isDessert
      ) {
        checked = checkedStarter && checkedDrinks && checkedDessert;
      } else if (
        this.menuGroup.maincourse_ids.length > 0 &&
        !this.menuGroup.isStarter &&
        this.menuGroup.starter_ids.length > 0
      ) {
        checked = checkedMain && checkedStarter;
      } else if (
        this.menuGroup.maincourse_ids.length > 0 &&
        !this.menuGroup.isStarter &&
        this.menuGroup.drink_ids.length > 0 &&
        this.menuGroup.isDrink
      ) {
        checked = checkedMain && checkedDrinks;
      } else if (
        this.menuGroup.maincourse_ids.length > 0 &&
        !this.menuGroup.isStarter &&
        this.menuGroup.dessert_ids.length > 0 &&
        this.menuGroup.isDessert
      ) {
        checked = checkedMain && checkedDessert;
      } else if (
        this.menuGroup.starter_ids.length > 0 &&
        this.menuGroup.drink_ids.length > 0 &&
        this.menuGroup.isDrink
      ) {
        checked = checkedStarter && checkedDrinks;
      } else if (
        this.menuGroup.starter_ids.length > 0 &&
        this.menuGroup.dessert_ids.length > 0 &&
        this.menuGroup.isDessert
      ) {
        checked = checkedStarter && checkedDessert;
      } else if (
        this.menuGroup.drink_ids.length > 0 &&
        this.menuGroup.isDrink &&
        this.menuGroup.dessert_ids.length > 0 &&
        this.menuGroup.isDessert
      ) {
        checked = checkedDrinks && checkedDessert;
      } else if (
        this.menuGroup.maincourse_ids.length > 0 &&
        !this.menuGroup.isStarter
      ) {
        checked = checkedMain;
      } else if (this.menuGroup.starter_ids.length > 0) {
        checked = checkedStarter;
      } else if (
        this.menuGroup.drink_ids.length > 0 &&
        this.menuGroup.isDrink
      ) {
        checked = checkedDrinks;
      } else if (
        this.menuGroup.dessert_ids.length > 0 &&
        this.menuGroup.isDessert
      ) {
        checked = checkedDessert;
      }

      return checked;
    },
    getEmail() {
      return this.$store.getters.getEmail(this.isAdmin);
    }
  },
  methods: {
    open() {
      this.selectedDrinks = [];
      this.selectedDessert = [];
      this.selectedStarters = [];
      this.selectedMaincourse = [];
      this.dialog = true;
      this.menuGroupItems = [];
    },
    checkBoxLabel(item) {
      let starter = this.menuGroup.starter_ids.find(x => x.id === item.id);
      if (starter) {
        return `${item.name +
          (starter && parseFloat(starter.additional_charge) > 0
            ? " (+" + starter.additional_charge + "€)"
            : "")}`;
      }

      let maincourse = this.menuGroup.maincourse_ids.find(
        x => x.id === item.id
      );
      if (maincourse) {
        return `${item.name +
          (maincourse && parseFloat(maincourse.additional_charge) > 0
            ? " (+" + maincourse.additional_charge + "€)"
            : "")}`;
      }

      let drink = this.menuGroup.drink_ids.find(
        x => x.id === item.id && this.menuGroup.isDrink
      );
      if (drink) {
        return `${item.name +
          (drink && parseFloat(drink.additional_charge) > 0
            ? " (+" + drink.additional_charge + "€)"
            : "")}`;
      }

      let dessert = this.menuGroup.dessert_ids.find(
        x => x.id === item.id && this.menuGroup.isDessert
      );
      if (dessert) {
        return `${item.name +
          (dessert && parseFloat(dessert.additional_charge) > 0
            ? " (+" + dessert.additional_charge + "€)"
            : "")}`;
      }
    },
    close() {
      this.dialog = false;
    },
    openCookingPointsDialog(item) {
      if (item.hasCookingPoints) {
        this.$refs.cookingPointsDialog.open(item);
        return;
      }
    },
    openIngredientsDialog(product, item) {
      if (
        product.hasMainIngredient &&
        product.ingredients &&
        product.ingredients.length
      ) {
        this.$refs.ingredienteDialog.open(
          item,
          product.ingredients,
          product.numberOfIngredients
        );
        return;
      }
    },
    selectStarters(product, index) {
      product.index = index;
      this.selectedStarters = [product];
      if (this.selectedStarters.some(item => item.id === product.id)) {
        this.groupItemToCart.push(product);
        let item = this.getItemDetails(product);
        this.openCookingPointsDialog(item);
        this.openIngredientsDialog(product, item);
      }
    },
    selectMaincourse(product, index) {
      product.index = index;
      this.selectedMaincourse = [product];
      if (this.selectedMaincourse.some(item => item.id === product.id)) {
        this.groupItemToCart.push(product);
        let item = this.getItemDetails(product);
        this.openCookingPointsDialog(item);
        this.openIngredientsDialog(product, item);
      }
    },
    selectDrinks(product, index) {
      product.index = index;
      this.selectedDrinks = [product];
      if (this.selectedDrinks.some(item => item.id === product.id)) {
        this.groupItemToCart.push(product);
        let item = this.getItemDetails(product);
        this.openCookingPointsDialog(item);
        this.openIngredientsDialog(product, item);
      }
    },
    selectDessert(product, index) {
      product.index = index;
      this.selectedDessert = [product];
      if (this.selectedDessert.some(item => item.id === product.id)) {
        this.groupItemToCart.push(product);
        let item = this.getItemDetails(product);
        this.openCookingPointsDialog(item);
        this.openIngredientsDialog(product, item);
      }
    },
    getItemDetails(product) {
      return {
        price: parseFloat(product.price),
        name: product.name,
        product_id: product.id,
        product_type_id: product.product_type_id,
        category_id: product.category_id,
        quantity: 1,
        size: this.size,
        order: this.getOrder(product, this.size),
        notes: "",
        stripeProduct: null,
        stripeSku: null,
        hasCookingPoints: product.hasCookingPoints || false,
        tableQR: this.tableQR,
        priceType: "unit",
        weight: null,
        email: this.getEmail,
        canBeShared: product.canBeShared || false,
        canBeMainCourse: product.canBeMainCourse || false,
        isAllowComment: product.isAllowComment,
        isPrinted: false,
        menu_group_id: this.menuGroup.id,
        isMenuGroupProduct: true,
        trans: product.trans
          ? product.trans
          : {
              name: {
                en: product.name,
                es: product.name,
                de: product.name,
                fr: product.name,
                it: product.name
              }
            },
        order_translations: {
          en: this.translateToOneLang("name", product, "en"),
          es: this.translateToOneLang("name", product, "es"),
          de: this.translateToOneLang("name", product, "de"),
          fr: this.translateToOneLang("name", product, "fr"),
          it: this.translateToOneLang("name", product, "it")
        }
      };
    },
    setMenuGroupItem(product) {
      let found = this.menuGroupItems.some(item => {
        if (
          item.name.toLowerCase().trim() === product.name.toLowerCase().trim()
        ) {
          return item;
        }
      });
      if (!found) {
        this.menuGroupItems.push(product);
      }
    },
    onDone() {
      if (!this.getEmail) {
        this.$refs.emailModalRef.open();
        return;
      }

      if (!this.tableQR || this.tableQR === NO_QR) {
        this.showErrorMessage("Table is yet not assigned");
        this.checkQR = true;
        return;
      }

      // check cart item length is greater then 20
      const { cart } = this.$store.state;
      const { admincart } = this.$store.state;
      if (cart.length >= 20) {
        this.showErrorMessage(this.$t("cart.theMaximumNumberOfProductAllowed"));
        return;
      }

      if (this.isAdmin && admincart.length >= 20) {
        this.showErrorMessage(this.$t("cart.theMaximumNumberOfProductAllowed"));
        return;
      }

      if (
        this.selectedStarters.length > 0 ||
        this.selectedMaincourse.length > 0 ||
        this.selectedDrinks.length > 0 ||
        this.selectedDessert.length > 0
      ) {
        let randomId = this.randomId();
        const item = {
          cart_item_id: randomId,
          price: parseFloat(this.menuGroup.price),
          name: this.menuGroup.name,
          product_id: this.menuGroup.id,
          quantity: 1,
          size: this.size,
          order: this.menuGroup.name + randomId,
          notes: "",
          stripeProduct: null,
          stripeSku: null,
          priceType: "unit",
          weight: null,
          tableQR: this.tableQR,
          email: this.getEmail,
          isPrinted: false,
          menu_group_id: this.menuGroup.id,
          isMenuGroupProduct: true,
          starters: this.selectedStarters
            ? this.selectedStarters.map(x => {
                let foundItem = this.menuGroupItems.find(
                  item =>
                    item.orderActual.toLowerCase().trim() ===
                    x.name.toLowerCase().trim()
                );
                if (foundItem) {
                  x.name = foundItem.name;
                }
                x.isPrinted = false;
                x.isDelivered = false;
                return x;
              })
            : [],
          maincourse: this.selectedMaincourse
            ? this.selectedMaincourse.map(x => {
                let foundItem = this.menuGroupItems.find(
                  item =>
                    item.orderActual.toLowerCase().trim() ===
                    x.name.toLowerCase().trim()
                );
                if (foundItem) {
                  x.name = foundItem.name;
                }
                x.isPrinted = false;
                x.isDeliveredMainCourse = false;
                return x;
              })
            : [],
          drinks: this.selectedDrinks
            ? this.selectedDrinks.map(x => {
                let foundItem = this.menuGroupItems.find(
                  item =>
                    item.orderActual.toLowerCase().trim() ===
                    x.name.toLowerCase().trim()
                );
                if (foundItem) {
                  x.name = foundItem.name;
                }
                x.isPrinted = false;
                x.isDelivered = false;
                return x;
              })
            : [],
          desserts: this.selectedDessert
            ? this.selectedDessert.map(x => {
                let foundItem = this.menuGroupItems.find(
                  item =>
                    item.orderActual.toLowerCase().trim() ===
                    x.name.toLowerCase().trim()
                );
                if (foundItem) {
                  x.name = foundItem.name;
                }
                x.isPrinted = false;
                x.isDelivered = false;
                return x;
              })
            : [],
          trans: this.menuGroup.trans
            ? this.menuGroup.trans
            : {
                name: {
                  en: this.menuGroup.name,
                  es: this.menuGroup.name,
                  de: this.menuGroup.name,
                  fr: this.menuGroup.name,
                  it: this.menuGroup.name
                }
              }
        };
        item.order_translations = {
          en: this.translateToOneLang("name", this.menuGroup, "en"),
          es: this.translateToOneLang("name", this.menuGroup, "es"),
          de: this.translateToOneLang("name", this.menuGroup, "de"),
          fr: this.translateToOneLang("name", this.menuGroup, "fr"),
          it: this.translateToOneLang("name", this.menuGroup, "it")
        };
        if (!this.isAdmin) {
          this.$store.commit("addToCart", {
            item: item,
            update: true
          });
          this.$store.dispatch("addStripeProductToCart", item);
        } else {
          item.cart_type = "admin";
          this.$store.commit("addToCart", {
            item: item,
            update: true
          });
          this.$store.dispatch("addStripeProductToCart", item);
        }
        this.$forceUpdate(); // Force update to fetch cart data (for displaying the new quantity)
        // this.groupItemToCart = [];
        this.selectedDrinks = [];
        this.selectedDessert = [];
        this.selectedStarters = [];
        this.selectedMaincourse = [];
        this.menuGroupItems = [];
        this.dialog = false;
      } else {
        return;
      }
    }
  }
};
</script>

<style></style>
